const table = document.querySelector('#comp_table') || 
             document.querySelector('.product-comparison-grid') ||
             document.querySelector('[class*="product-comparison"]');

if (table) {
    const headerRow = table.querySelector('thead tr');
    const thead = table.querySelector('thead');
    let isSticky = false;
    let originalHeaderTop = null;
    let headerHeight = null;
    let placeholder = null;
    let sliderContainer = null;
    let initialSliderScrollLeft = 0;
    let isInitialized = false;
    
    // Cleanup beim Laden - entferne eventuelle sticky Reste
    const cleanup = () => {
        if (headerRow) {
            headerRow.removeAttribute('data-sticky');
            headerRow.style.width = '';
            headerRow.style.left = '';
            headerRow.style.top = '';
        }
        
        const existingPlaceholder = document.querySelector('[data-sticky-placeholder="true"]');
        if (existingPlaceholder) {
            existingPlaceholder.remove();
        }
        
        isSticky = false;
        placeholder = null;
    };
    
    const findSliderContainer = () => {
        const slider = document.querySelector('.slider[style*="overflow-x: scroll"]') ||
                      document.querySelector('[data-overlayscrollbars-viewport="scrollbarHidden"]') ||
                      document.querySelector('.product-comparison-slider');
        
        return slider;
    };
    
    const measureOriginalPosition = () => {
        if (isSticky) return false;
        
        if (table.offsetHeight === 0 || thead.offsetHeight === 0) {
            // console.log('Elemente noch nicht bereit für Messung');
            return false;
        }
        
        const headerRect = thead.getBoundingClientRect();
        const newHeaderTop = headerRect.top + window.scrollY;
        
        if (newHeaderTop < 0 || newHeaderTop > 50000) {
            // console.log('Unrealistische headerTop Position:', newHeaderTop);
            return false;
        }
        
        originalHeaderTop = newHeaderTop;
        headerHeight = headerRow.getBoundingClientRect().height;
        
        sliderContainer = findSliderContainer();
        if (sliderContainer) {
            initialSliderScrollLeft = sliderContainer.scrollLeft;
        }
        
        // console.log('Position gemessen - HeaderTop:', originalHeaderTop, 'Current ScrollY:', window.scrollY);
        return true;
    };
    
    const getCurrentTestGridBottom = () => {
        const testGrids = document.querySelectorAll('test-values-grid');
        if (testGrids.length > 0) {
            const lastGrid = testGrids[testGrids.length - 1];
            const lastGridRect = lastGrid.getBoundingClientRect();
            return lastGridRect.bottom + window.scrollY;
        } else {
            const tableRect = table.getBoundingClientRect();
            return tableRect.bottom + window.scrollY;
        }
    };
    
    const createPlaceholder = () => {
        placeholder = document.createElement('tr');
        placeholder.style.height = headerHeight + 'px';
        placeholder.style.visibility = 'hidden';
        placeholder.style.pointerEvents = 'none';
        placeholder.setAttribute('data-sticky-placeholder', 'true');
        
        const originalThs = headerRow.querySelectorAll('th');
        originalThs.forEach(() => {
            const placeholderTh = document.createElement('th');
            placeholderTh.style.padding = '0';
            placeholderTh.style.margin = '0';
            placeholderTh.style.border = 'none';
            placeholder.appendChild(placeholderTh);
        });
        
        headerRow.parentNode.insertBefore(placeholder, headerRow.nextSibling);
    };
    
    const removePlaceholder = () => {
        if (placeholder) {
            placeholder.remove();
            placeholder = null;
        }
    };
    
    const getCurrentTableWidth = () => {
        const tableScrollWidth = table.scrollWidth;
        const theadScrollWidth = thead.scrollWidth;
        const tbody = table.querySelector('tbody');
        const tbodyScrollWidth = tbody ? tbody.scrollWidth : 0;
        
        const baseWidth = Math.max(tableScrollWidth, theadScrollWidth, tbodyScrollWidth);
        return baseWidth + 20;
    };
    
    const calculateHorizontalOffset = () => {
        if (!sliderContainer) return 0;
        
        const currentScrollLeft = sliderContainer.scrollLeft;
        const offset = initialSliderScrollLeft - currentScrollLeft;
        
        return offset;
    };
    
    const updatePosition = () => {
        if (!isSticky) return;
        
        const horizontalOffset = calculateHorizontalOffset();
        const tableRect = table.getBoundingClientRect();
        const adjustedLeft = tableRect.left + horizontalOffset;
        
        const fullWidth = getCurrentTableWidth();
        const headerElement = document.querySelector('.header');
        const headerElementHeight = headerElement ? headerElement.getBoundingClientRect().height : 0;
        
        headerRow.style.width = fullWidth + 'px';
        headerRow.style.left = adjustedLeft + 'px';
        headerRow.style.top = (headerElementHeight - 1) + 'px';
    };
    
    const activateSticky = () => {
        if (isSticky) return;
        // console.log('Aktiviere Sticky');
        isSticky = true;
        
        createPlaceholder();
        headerRow.setAttribute('data-sticky', 'true');
        
        updatePosition();
    };
    
    const deactivateSticky = () => {
        if (!isSticky) return;
        // console.log('Deaktiviere Sticky');
        isSticky = false;
        
        headerRow.removeAttribute('data-sticky');
        headerRow.style.width = '';
        headerRow.style.left = '';
        headerRow.style.top = '';
        
        removePlaceholder();
    };
    
    const checkSticky = () => {
        if (!isInitialized || originalHeaderTop === null) {
            // console.log('Nicht initialisiert, überspringe sticky check');
            return;
        }
        
        const currentScrollY = window.scrollY;
        const currentTestGridBottom = getCurrentTestGridBottom();
        
        const shouldBeSticky = currentScrollY > (originalHeaderTop + 400) && 
                             currentScrollY < (currentTestGridBottom - 400);
        
        // console.log('Sticky Check - ScrollY:', currentScrollY, 'HeaderTop+400:', originalHeaderTop + 400, 'ShouldBe:', shouldBeSticky);
        
        if (shouldBeSticky && !isSticky) {
            activateSticky();
        } else if (!shouldBeSticky && isSticky) {
            deactivateSticky();
        }
    };
    
    const forceCheckSticky = () => {
        // Erzwinge Sticky-Check auch wenn nicht initialisiert
        if (originalHeaderTop === null) return;
        
        const currentScrollY = window.scrollY;
        const currentTestGridBottom = getCurrentTestGridBottom();
        
        const shouldBeSticky = currentScrollY > (originalHeaderTop + 400) && 
                             currentScrollY < (currentTestGridBottom - 400);
        
        // console.log('Force Sticky Check - ScrollY:', currentScrollY, 'HeaderTop+400:', originalHeaderTop + 400, 'ShouldBe:', shouldBeSticky);
        
        if (shouldBeSticky && !isSticky) {
            activateSticky();
        } else if (!shouldBeSticky && isSticky) {
            deactivateSticky();
        }
    };
    
    const initializeWhenReady = () => {
        if (isInitialized) return;
        
        const success = measureOriginalPosition();
        
        if (success) {
            isInitialized = true;
            // console.log('Erfolgreich initialisiert');
            
            // Nach Initialisierung immer sticky check durchführen
            setTimeout(() => {
                checkSticky();
                // Zusätzlicher Check nach kurzer Verzögerung
                setTimeout(forceCheckSticky, 500);
            }, 100);
        } else {
            // console.log('Initialisierung fehlgeschlagen, versuche erneut...');
            setTimeout(initializeWhenReady, 100);
        }
    };
    
    if (thead && headerRow) {
        // Sofortiges Cleanup beim Laden
        cleanup();
        
        setTimeout(initializeWhenReady, 100);
        setTimeout(initializeWhenReady, 500);
        setTimeout(initializeWhenReady, 1000);
        setTimeout(initializeWhenReady, 2000);
        
        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    checkSticky();
                    updatePosition();
                    ticking = false;
                });
                ticking = true;
            }
        };
        
        const handleResize = () => {
            // console.log('Resize - Neu initialisieren');
            cleanup();
            isInitialized = false;
            setTimeout(initializeWhenReady, 100);
        };
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleResize);
        window.addEventListener('load', () => {
            // console.log('Window loaded - Neu initialisieren');
            cleanup();
            isInitialized = false;
            setTimeout(initializeWhenReady, 100);
        });
        
        // Zusätzlicher Check bei Page-Visibility-Change (Tab-Wechsel)
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden && isInitialized) {
                setTimeout(forceCheckSticky, 100);
            }
        });
        
        const setupSliderListener = () => {
            if (sliderContainer && !sliderContainer.hasEventListener) {
                sliderContainer.addEventListener('scroll', handleScroll, { passive: true });
                sliderContainer.hasEventListener = true;
            }
        };
        
        document.addEventListener('scroll', (e) => {
            if (!sliderContainer && e.target !== window && e.target !== document) {
                const newSlider = findSliderContainer();
                if (newSlider && newSlider !== sliderContainer) {
                    sliderContainer = newSlider;
                    setupSliderListener();
                }
            }
        }, { passive: true, capture: true });
        
        setTimeout(setupSliderListener, 500);
    }
}
